import React from "react";
import { Button, ButtonGroup, Paper, Stack, Table, TableBody, TableCell, TableContainer, TableRow } from "@mui/material";
import CardHeaderTitle from "../../components/card-header-title/index.jsx";
import { toggleButtonStyle } from "../../consts.js";

const TopQuestionsCard = ({ data, colours, themeMode }) => {
    const [pickedAgent, setPickedAgent] = React.useState("agent");

    return (
        <Paper
            sx={{ display: "flex", flexDirection: "column", width: '100%', borderRadius: 2.5, padding: 3, boxSizing: "border-box" }}
        >
            <Stack
                direction="row"
                flexWrap="wrap"
                gap={.5}
                justifyContent="space-between"
                alignItems="center"
            >
                <CardHeaderTitle
                    title="Top Questions"
                    tooltip="The top questions asked by Agents and Clients."
                />

                <ButtonGroup
                    variant="contained"
                    aria-label="outlined primary button group"
                    className="buttons-border-extend"
                >
                    <Button
                        onClick={() => setPickedAgent("agent")}
                        style={toggleButtonStyle(pickedAgent === "agent", colours, themeMode)}
                    >
                        Agent
                    </Button>
                    <Button
                        onClick={() => setPickedAgent("client")}
                        style={toggleButtonStyle(pickedAgent === "client", colours, themeMode)}
                    >
                        Client
                    </Button>
                </ButtonGroup>
            </Stack>
            <div style={{ marginTop: 16 }}>
                <TableContainer>
                    <Table size="small" aria-label="Top Questions Table">
                        <TableBody>
                            {data[pickedAgent].sort((a, b) => b.n - a.n).map((z, zi) => (
                                <TableRow hover key={zi}>
                                    <TableCell
                                        style={{
                                            paddingTop: 3,
                                            paddingBottom: 3,
                                        }}
                                    >
                                        {zi + 1 + ". " + z.text}
                                    </TableCell>
                                </TableRow>
                            ))}
                            {!data[pickedAgent].length ? (
                                <TableRow>
                                    <TableCell>
                                        No Data Available
                                    </TableCell>
                                </TableRow>
                            ) : ("")}
                        </TableBody>
                    </Table>
                </TableContainer>
            </div>
        </Paper>
    );
};

export default TopQuestionsCard;
